module.exports = "/_next/static/images/045acef08731a9ef94165a4378729162-pregnant-woman@desktop@1x.jpg.webp";